module.exports = __webpack_public_path__ + "static/media/tickleLetterSite@2x.3afab399.png";